import request from "@/router/axios"
export const get = (params) => {
    return request({
        url: `/api/zl/bill/get`,
        method: 'get',
        params
    })
}
export const getDetail = (appId) => {
    return request({
        url: `/api/zl/record/getDetail`,
        method: 'get',
        params: {
            appId
        }
    })
}